"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("../colors"));
const accordion = {
    MuiAccordion: {
        styleOverrides: {
            rounded: {
                "&:last-of-type": { borderRadius: "0 0 1rem 1rem" },
            },
            root: {
                boxShadow: "none",
                border: `1px solid ${colors_1.default.border[700]}`,
                // ensures borderBottom of 1st accordion and borderTop of 2nd accordion doesn't both show borders when there are multiple accordions
                "&.MuiAccordion-root + .MuiAccordion-root": {
                    borderTop: "solid thin transparent",
                },
                "&:first-of-type": {
                    ".MuiAccordionSummary-root": {
                        borderRadius: "1rem 1rem 0 0",
                    },
                    ".MuiAccordionSummary-root.Mui-expanded": {
                        borderRadius: "inherit",
                    },
                },
                "&:last-of-type": {
                    ".MuiAccordionSummary-root": {
                        borderBottomLeftRadius: "1rem",
                        borderBottomRightRadius: "1rem",
                    },
                    ".MuiAccordionSummary-root.Mui-expanded": {
                        borderRadius: 0,
                    },
                },
                "&:first-of-type:last-of-type": {
                    ".MuiAccordionSummary-root": {
                        borderRadius: "inherit",
                    },
                },
                "&.MuiPaper-rounded": {
                    "&:first-of-type": {
                        borderTopLeftRadius: "1rem",
                        borderTopRightRadius: "1rem",
                    },
                },
                "&.Mui-expanded": {
                    margin: 0,
                },
            },
        },
    },
    MuiAccordionSummary: {
        styleOverrides: {
            root: {
                backgroundColor: colors_1.default.secondary[600],
                "&.Mui-expanded ": {
                    minHeight: "48px",
                },
            },
            content: {
                justifyContent: "space-between",
                margin: 0,
                "&.Mui-expanded ": {
                    margin: 0,
                },
            },
        },
    },
};
exports.default = accordion;
